import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut, } from "firebase/auth";
import { collection, query, where, getDocs, doc, getDoc, updateDoc, setDoc } from "firebase/firestore";


// 🔄 Auto-sync authUid between Auth user and staff record
async function syncAuthUidForUser(email, uid) {
  if (!email) return;

  try {
    // Try to find the staff record with matching email
    const staffQuery = query(
      collection(db, "staff"),
      where("email", "==", email.toLowerCase())
    );
    const staffSnap = await getDocs(staffQuery);

    if (staffSnap.empty) {
      console.log(`⚠️ No staff record found for ${email}`);
      return;
    }

    const staffDoc = staffSnap.docs[0];
    const staffData = staffDoc.data();

    // If missing authUid, update it
    if (!staffData.authUid) {
      const authUid = uid || `local_${email.replace(/[@.]/g, "_")}`;
      await updateDoc(doc(db, "staff", staffDoc.id), { authUid });
      console.log(`✅ Linked staff authUid for ${email}`);
    }
  } catch (err) {
    console.error("❌ Failed to sync authUid:", err);
  }
}



const AuthContext = createContext();
const LOCAL_STORAGE_KEY = "convalesce_users";

// ✅ Ensure local admin always exists
function ensureAdminExists() {
  const users = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
  const adminEmail = "admin@convalesce.com";
  const existingAdmin = users.find((u) => u.email === adminEmail);

  if (!existingAdmin) {
    users.push({
      name: "Admin User",
      email: adminEmail,
      password: "Admin123!",
      role: "admin",
    });
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(users));
  }
  return users;
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("loggedInUser")) || null
  );

  const signUp = async ({ name, email, password }) => {
  try {
    const cred = await createUserWithEmailAndPassword(auth, email, password);

    const safeId = email.toLowerCase().replace(/[@.]/g, "_");
    await setDoc(
      doc(db, "users", safeId),
      {
        name,
        email: email.toLowerCase(),
        role: "user",
        authUid: cred.user.uid,
        createdAt: new Date().toISOString(),
      },
      { merge: true }
    );

    // await syncAuthUidForUser(email, cred.user.uid);

    return true;
  } catch (e) {
    console.error("Sign-up error:", e);
    return false;
  }
};


  const login = async (email, password) => {
  try {
    // ✅ real password verification
    const cred = await signInWithEmailAndPassword(auth, email, password);

    // ✅ get role/name from Firestore profile
    const safeId = email.toLowerCase().replace(/[@.]/g, "_");
    const snap = await getDoc(doc(db, "users", safeId));
    const data = snap.exists() ? snap.data() : {};

    const loggedIn = {
      name: data.name || "User",
      email: email.toLowerCase(),
      role: data.role || "user",
      uid: cred.user.uid,
    };

    setUser(loggedIn);
    localStorage.setItem("loggedInUser", JSON.stringify(loggedIn));

    // ✅ update lastLogin + ensure authUid is stored
    await setDoc(
      doc(db, "users", safeId),
      { lastLogin: new Date().toISOString(), authUid: cred.user.uid },
      { merge: true }
    );

    // 🔗 If you want: sync staff record using REAL uid
    // await syncAuthUidForUser(loggedIn.email, cred.user.uid);

    return true;
  } catch (e) {
    console.error("Login error:", e);
    return false;
  }
};


 const logout = async () => {
  await signOut(auth);
  setUser(null);
  localStorage.removeItem("loggedInUser");
};


  return (
    <AuthContext.Provider value={{ user, login, logout, signUp }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
